
import {ResourceTaskTime} from "./ResourceTaskTime";
import {Task} from "app/entities/Task";
import {TaskPageModel} from "./PageModel";

export enum CalendarFilter {All = 0, Job = 1, Task = 2}

export class Calendar{
  ResourceTaskTimes?: ResourceTaskTime[];
  UnPlannedTasks?: TaskPageModel;
  PlannedTasks?: TaskPageModel;
  CurrentTasks?: Task[];
}




// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/Calendar.ts